import KComponent from '../../core/KComponent'
import Icon from '../icon'
import Ripple from '../ripple'

export default new KComponent({
  name: 'KCarouselControl',
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleClick(direction) {
      if (direction === 'left') {
        this.$parent.prev('control')
      } else {
        this.$parent.next('control')
      }
    },
  },
  render() {
    return (
      <div
        class={{
          'km-carousel__controls': true,
          'km-carousel__controls--hover': this.hover,
        }}>
        <Ripple
          class="km-carousel__control km-carousel__control--left"
          kCentered={true}
          nativeOnClick={() => {
            this.handleClick('left')
          }}
        >
          <Icon name="chevron-left"></Icon>
        </Ripple>
        <Ripple
          class="km-carousel__control km-carousel__control--right"
          kCentered={true}
          nativeOnClick={() => {
            this.handleClick('right')
          }}
        >
          <Icon name="chevron-right"></Icon>
        </Ripple>
      </div>
    )
  }
  ,
})
